import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../styling/shared/event-row.css';
import defaultEventImage from '../../assets/default-event-image.png';
import {GoCalendar, GoClock, GO} from 'react-icons/lib/go';
import {FaMoney} from 'react-icons/lib/fa';
import moment from 'moment';
import 'moment/locale/pt-br'

const propTypes = {
  // The Event to be rendered
  event: PropTypes.object.isRequired,
};

class EventRow extends Component {

  setRange(event) {
    let range = [];
    event.tickets.nodes.forEach(function(ticket) {
      ticket.batches.nodes.forEach(function(batch) {
        range.push(batch.price/100);
      })
    })

    if(range.length === 0) return ''

    range = range.sort(function(a, b) { return a > b }).filter(function(item, pos, ary){
      return !pos || item != ary[pos - 1];
    });

    if(range.length == 1) {
      return "R$ " + range[0];
    } else {
      return "R$ " + range[0] + " a R$ " + range[range.length - 1];
    }
  }

  render() {
    const event = this.props.event;
    let eventPhoto = defaultEventImage;
    if (event.photo && event.photo.small_url) {
      eventPhoto = event.photo.small_url;
    }

    const range = this.setRange(event)
    console.log(range);
    moment.locale('pt-br')

    return (
      <div className="events-event col-12 mb-4">
        <div className="card">
          <div className="card-body" style={{backgroundColor: '#ebfaff'}}>
            <h5 className="card-title events-event__title">{moment(event.starts_at.slice(0, -6)).format('ll')} - {event.name}</h5>
            <a href={`${event.share_link}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-block btn-secondary">COMPRAR INGRESSOS</a>
          </div>
        </div>
      </div>
    );
  }
}

EventRow.propTypes = propTypes;

export default EventRow;



// WEBPACK FOOTER //
// ./src/component/shared/event-row.js